import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { FeatureDividedVertically } from '@/components/ui/features/white-glove-service/DetailsSection/components/FeatureDividedVertically';

export const DetailsSection = () => {
  const { t } = useTranslation();

  return (
    <Container textAlign="center" pb={20}>
      <Flex textAlign="center" flexDirection="column" alignItems="center" maxW="800px" margin="auto">
        <Text fontFamily="heading" fontSize="3xl">
          {t('whiteGloveServicePage.detailsHeading.0')}
        </Text>
        <Text lineHeight={1} fontSize="3xl" fontFamily="heading" fontWeight="bold" color="violet.500">
          {t('whiteGloveServicePage.detailsHeading.1')}
        </Text>
        <Text mt={6}>{t('whiteGloveServicePage.detailsDescription')}</Text>
      </Flex>
      <Heading color="violet.500" fontSize="3xl" mb={8} mt={16}>
        {t('whiteGloveServicePage.personalizedService')}
      </Heading>
      <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.0.title')}
          description={t('whiteGloveServicePage.featuredList.0.description')}
        />
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.1.title')}
          description={t('whiteGloveServicePage.featuredList.1.description')}
        />
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.2.title')}
          description={t('whiteGloveServicePage.featuredList.2.description')}
        />
      </Flex>
      <Heading color="violet.500" fontSize="3xl" mb={8} mt={16}>
        {t('whiteGloveServicePage.eventManagement')}
      </Heading>
      <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.3.title')}
          description={t('whiteGloveServicePage.featuredList.3.description')}
        />
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.4.title')}
          description={t('whiteGloveServicePage.featuredList.4.description')}
        />
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.5.title')}
          description={t('whiteGloveServicePage.featuredList.5.description')}
        />
      </Flex>
      <Heading color="violet.500" fontSize="3xl" mb={8} mt={16}>
        {t('whiteGloveServicePage.productionAndTraining')}
      </Heading>
      <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.6.title')}
          description={t('whiteGloveServicePage.featuredList.6.description')}
        />
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.7.title')}
          description={t('whiteGloveServicePage.featuredList.7.description')}
        />
        <FeatureDividedVertically
          title={t('whiteGloveServicePage.featuredList.8.title')}
          description={t('whiteGloveServicePage.featuredList.8.description')}
        />
      </Flex>
    </Container>
  );
};
